import { Vue, Watch, Component, Prop } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import style from './style.vue';
import Sketch from '@/views/components/sketch';
import ShopDisplayEdit from '@/views/components/shopDisplaySketchMap/displayEdit';
import { IPSService } from '@/services/ipsServices';

const ConfigSaveService = ['shareConfigSave', 'siteShareConfigSave', 'siteShareConfigEdit'];

const ConfigInfoService = ['shareConfigInfo', 'siteShareConfigInfo', 'siteShareConfigDetail'];

@Component({
  mixins: [style],
  components: { Sketch, ShopDisplayEdit },
})
export default class ShareConfig extends Vue {
  // 1 网点配置 0 网点组配置
  @Prop()
    fromPage: number;

  //  关键参数 网点或网点组Id
  @Prop({ default: () => {} })
    postParams: ItemObject;

  $refs: {
    form: any;
  };

  data: ItemObject = {
    fieldType: 'ShareConfig',
    isDefault: 0,
    sgId: 0,
    siteId: 0,
    shareInfo: {
      sharePicture: '',
      shareTitle: '',
      description: '',
      shareCardPicture: '',
    },
  };

  // 默认分享设置的信息
  defaultData: ItemObject = {
    fieldType: 'ShareConfig',
    isDefault: 0,
    sgId: 0,
    siteId: 0,
    shareInfo: {
      sharePicture: '',
      shareTitle: '',
      description: '',
      shareCardPicture: '',
    },
  };

  // 是否使用默认 0 使用默认 1 使用自定义
  isUseDefault = 0;

  // 运营模式
  mode = 0;

  get getSketchData() {
    const result = this.isUseDefault ? this.data : this.defaultData;
    return [
      {
        img: result.shareInfo.sharePicture,
        title: result.shareInfo.shareTitle || ' ',
        description: result.shareInfo.description,
      },
      { img: result.shareInfo.shareCardPicture, title: '' },
    ];
  }

  mounted() {
    this.mode = +this.$route.params.mode;
    IPSService[ConfigInfoService[this.mode === 2 ? 2 : this.fromPage]]({
      postParams: this.postParams,
    }).then((response) => {
      response.fieldType = 'ShareConfig';
      this.data = response;
      this.data.shareInfo = Object.assign({}, { sharePicture: '', shareTitle: '', description: '', shareCardPicture: '' }, response.shareInfo);
      if (this.mode === 2) {
        this.data.isDefault = 1;
      }
      this.isUseDefault = this.data.isDefault === 0 ? 0 : 1;
      if (this.fromPage === 1 && this.mode == 1) {
        IPSService[ConfigInfoService[0]]({
          postParams: this.postParams,
        }).then((result) => {
          result.fieldType = 'ShareConfig';
          this.defaultData = result;
          this.defaultData.shareInfo = Object.assign({}, { sharePicture: '', shareTitle: '', description: '', shareCardPicture: '' }, result.shareInfo);
        });
      }
    });
  }

  onChange(val) {
    this.isUseDefault = val;
  }

  onSave() {
    this.$refs.form.$refs.ShareConfig.$refs.form.validate((result) => {
      if (result) {
        delete this.data.fieldType;
        if (this.mode === 2) {
          this.data.fieldType = 'ShareImage';
        }
        IPSService[ConfigSaveService[this.mode === 2 ? 2 : this.fromPage]]({
          postParams: Object.assign({}, this.data, this.postParams),
        }).then((response) => {
          this.$message.success('保存成功');
        });
      }
    });
  }

  render(h) {
    return (
      <section class="nav-Menu share-config r-pt-0 r-pr-0">
        {/* <p class="nav-title nav-banges">
          <span>分享海报示意图</span>
        </p> */}
        <div class="messageBlock">
          <span class="redText">*&nbsp;</span>
          {this.$route.params.mode == '2' && this.fromPage ? '分享功能需要搭配悬浮图标使用，请在需要分享功能的页面配置好链接分享的悬浮图标。' : '此处配置后将用于首页和微页面的分享展示，如需在首页分享海报，请在首页配置上分享悬浮按钮。'}
        </div>
        <div class="nav-container" style="height: calc(100% - 70px)">
          <div class="left-phone  overflow-auto-y bg-white" style="width: 20vw;border: none;min-width:375px">
            <Sketch component-keys={['sharePoster', 'shareCard']} sketch-data={this.getSketchData} showAddress={this.mode == 1} logo={this.data.shareInfo.siteLogo ? `${this.data.shareInfo.siteLogo}?imageView2/1/w/150/h/150` : ''} />
          </div>
          <ShopDisplayEdit v-model={this.data} params={this.postParams} fromPage={this.fromPage} ref="form" onChange={this.onChange.bind(this)} />
        </div>
        <div class="bottom-save">
          <el-button type="primary" class="save-btn" onClick={this.onSave}>
            保存
          </el-button>
        </div>
      </section>
    );
  }
}
